import React from 'react'
import './loading.css'

const Loading = () => {
  return (
    <div className="flex w-full h-[100dvh] z-[1000] justify-center items-center absolute">
      <div className="flex justify-center items-center w-[100px] h-[100px] bg-slate-200 dark:bg-gray-800 shadow-lg rounded-md">
        <div className="cssloader">
          <div className="triangle1" />
          <div className="triangle2" />
        </div>
      </div>
    </div>
  );
}

export default Loading